import { useRouter } from "next/router";
import { Fragment, useEffect, useState } from "react";
import ProductSmallTile from "../../components/product-tile/product-small-tile";
import { server } from "./../../config";
import styles from "./sok.module.css";
import Paginator from "../../components/paginator/paginator";
import Head from "next/head";
import SearchFilter from "../../components/search-filter/search-filter";
import SearchFilterMobile from "../../components/search-filter-mobile/search-filter-mobile";
export default function SearchPage() {
  const [loading, setLoading] = useState(true);
  const [result, setResult] = useState<any[] | null>([]);
  const [page, setPage] = useState(1);
  const [totalRows, setTotalRows] = useState(0);
  const [brandAgg, setBrandAgg] = useState<any[]>([]);
  const [priceAgg, setPriceAgg] = useState<any[]>([]);
  const { q } = useRouter().query;
  const [title, setTitle] = useState("Produktsøk");
  const [validPriceRanges, setValidPriceRanges] = useState<
    { min: number; max: number }[]
  >([]);
  const [validBrands, setValidBrands] = useState<string[]>([]);
  const [defaultSortOrder, setDefaultSortOrder] = useState<string>("relevance");
  useEffect(() => {
    if (q != undefined) {
      setPage(1);
      search().then();
      getTotal().then();
      let title = q.toString();
      if (title.length > 0) {
        title = title.charAt(0).toUpperCase() + title.slice(1);
        setTitle(title);
      }
    }
  }, [q]);

  useEffect(() => {
    getTotal().then();
    search().then();
  }, [page, validPriceRanges, validBrands, defaultSortOrder]);

  const getTotal = async () => {
    let query = q?.toString() || "";
    if (query.split(" ").length > 2) {
      query = `"${query}"`;
    }
    const response = await fetch(`${server}/api/getTotal`, {
      method: "POST",
      body: JSON.stringify({
        validPriceRanges: validPriceRanges || [],
        validBrands: validBrands || [],
        q: query,
        page: page,
      }),
    });
    const res = await response.json();
    setTotalRows(res);
  };

  const search = async () => {
    setLoading(true);
    let query = q?.toString() || "";
    if (query.split(" ").length > 2) {
      query = `"${query}"`;
    }
    const response = await fetch(`${server}/api/search`, {
      method: "POST",
      body: JSON.stringify({
        validPriceRanges: validPriceRanges || [],
        validBrands: validBrands || [],
        q: query,
        page: page,
        defaultSortOrder: defaultSortOrder,
      }),
    });
    const res = await response.json();
    let brandAgg = res.brandAgg.filter((a: unknown) => {
      if (a instanceof Object && "_id" in a && typeof a._id === "string" && a._id.trim() !== "") {
        return true;
      }
    });
    setBrandAgg(brandAgg);
    setPriceAgg(res.priceAgg || []);
    setResult(res.searchResult);
    setLoading(false);
  };

  const renderContent = () => {
    if (loading) {
      return <div>Søker...</div>;
    }
    if (result == null) {
      return <div>En feil har oppstått. Vennligst frisk opp siden.</div>;
    }
    if (result.length === 0) {
      return (
        <>
          <div style={{ fontWeight: 500, fontSize: "16px", marginTop: "64px" }}>
            Vi fant dessverre ingen produkter som matchet ditt søkekritere.
            <br />
            Prøv å endre søkekriteriet ditt.
          </div>
        </>
      );
    }
    if (result.length > 0) {
      return result.map((product: any, index: number) => {
        return (
          <ProductSmallTile
            detailsPath={`produkter/${product.brand}`}
            size="normal"
            product={product}
            key={`searchResult${index}`}
          />
        );
      });
    }
  };

  return (
    <>
      <Head>
        <title>{`${title} - Stort utvalg fra kjente butikker | Sportsam.no`}</title>
        <meta name="viewport" content="width=device-width, initial-scale=1.0" />
        <meta name="description" content={`På jakt etter ${title}? Vi samler produkter fra ulike sportsbutikker så du enkelt kan sammenligne og kjøpe på nett.`} />
        <meta name="og:title" content={`${title} - Stort utvalg fra kjente butikker | Sportsam.no`} />
        <meta name="og:description" content={`På jakt etter ${title}? Vi samler produkter fra ulike sportsbutikker så du enkelt kan sammenligne og kjøpe på nett.`} />
      </Head>
      <div className={styles.wrapper}>
        <div className="hideInMobile" style={{ minWidth: "262px" }}>
          <SearchFilter
            brandAgg={brandAgg}
            priceAgg={priceAgg}
            query={q?.toString()}
            totalRows={totalRows}
            setValidPriceRanges={setValidPriceRanges}
            validPriceRanges={validPriceRanges}
            validBrands={validBrands}
            setValidBrands={setValidBrands}
            defaultSortOrder={defaultSortOrder}
            setDefaultSortOrder={setDefaultSortOrder}
          ></SearchFilter>
        </div>
        <main style={{ textAlign: "center", flexGrow: 2 }}>
          <SearchFilterMobile
            brandAgg={brandAgg}
            priceAgg={priceAgg}
            query={q?.toString()}
            totalRows={totalRows}
            setValidPriceRanges={setValidPriceRanges}
            validPriceRanges={validPriceRanges}
            validBrands={validBrands}
            setValidBrands={setValidBrands}
            defaultSortOrder={defaultSortOrder}
            setDefaultSortOrder={setDefaultSortOrder}
          />
          <section>{renderContent()}</section>
          <br />
          {totalRows > 0 ? (
            <Paginator totalRows={totalRows} setPage={setPage} page={page} />
          ) : (
            <></>
          )}
          <div className="hideInMobile hideOnPad" style={{marginBottom: '32px'}}><a href="https://www.partner-ads.com/no/klikbanner.php?partnerid=30465&bannerid=87165" target="_blank" rel="nofollow noopener"> <img src="https://www.partner-ads.com/no/visbanner.php?partnerid=30465&bannerid=87165" alt="" /></a></div>
        </main>
      </div>
    </>
  );
}
